import React from "react";
import FormContentWrapper from "Components/FormContentWrapper";
import { useFormData } from "Contexts/FormDataContext";
import { useSession } from "Contexts/SessionContext";
import usePageContextUpdate from "Hooks/usePageContextUpdate";
import TopGoalsFormContent from "Components/TopGoals/TopGoalsFormContent";
import TopGoalsInfoContent from "Components/TopGoals/TopGoalsInfoContent";
import { getPageNumber } from "Data";

const TopGoalsPage = () => {
  const { currentPageData, setSubmitted } = usePageContextUpdate();

  const {
    updateTopMarketingGoals,
    currentFormData: { topMarketingGoals },
  } = useFormData();

  const { updateSession, sessionData } = useSession();

  const handleSubmit = async (selectedGoals) => {
    updateTopMarketingGoals(selectedGoals);

    await updateSession({
      current_page: getPageNumber("marketing-pain-points"),
      responses: {
        ...sessionData?.responses,
        q8_goals: {
          goals: selectedGoals,
        },
      },
    });

    setSubmitted(true);
  };

  return (
    <FormContentWrapper
      infoContent={<TopGoalsInfoContent heading={currentPageData.pageTitle} />}
      formFieldContent={
        <TopGoalsFormContent
          submitCB={handleSubmit}
          defaultGoals={topMarketingGoals}
        />
      }
    />
  );
};

export default TopGoalsPage;
